export default __webpack_public_path__ + "static/media/pursuit-menu-myresults-on.dc70ac77.svg";